import { IPurchaseStateWithCustomerRelationship } from "@smartrr/shared/entities/PurchaseState";
import { useCallback } from "react";

import { useToast } from "@vendor-app/app/_sharedComponents/Toast/ToastProvider";
import { putCustomerPurchaseStateSellingPlan } from "@vendor-app/app/_state/actionCreators/customerPurchaseState";
import { useSmartrrVendorDispatch } from "@vendor-app/app/_state/typedVendorReduxHooks";

export const useUpdateSellingPlan = (
  customerPurchaseState: IPurchaseStateWithCustomerRelationship,
  onCommitStart?: () => void,
  onCommitEnd?: () => void
) => {
  const dispatch = useSmartrrVendorDispatch();
  const { addToast } = useToast();

  return useCallback(
    async (sellingPlanId: number) => {
      if (!(customerPurchaseState && customerPurchaseState.custRel)) {
        return;
      }

      onCommitStart && onCommitStart();
      await dispatch(
        putCustomerPurchaseStateSellingPlan({
          custRelId: customerPurchaseState.custRel.id,
          cpsId: customerPurchaseState.id,
          sellingPlanId,
        })
      )
        .then(res => {
          if (res.type === "UPDATED_CPS_SELLING_PLAN") {
            addToast("Program updated");
            return;
          }
          if (res.type === "ERROR_UPDATING_CPS_SELLING_PLAN") {
            addToast("Error updating subscription program", true);
          }
        })
        .catch(error => {
          addToast("Error updating subscription program", true);
        });
      onCommitEnd && onCommitEnd();
    },
    [customerPurchaseState]
  );
};
